import http from "@/apis/http";
import url from "@/config/url";

const api = url.tgBusiness.ranking;

export default {
    bet_ranking: {
        getData: (params) => http.post(api.search, params),
        getColumns: (params) => http.post(api.columns, params),
    }
}